import styled from 'styled-components';
import { shorthandSpacingCss } from '../primitives/Spacer';

export const StyledFlex = styled('div')`
  ${shorthandSpacingCss}
`;
